<template>
  <div>

    <el-upload ref="upload" :class="[
      'l-upload', 'myupload',
      { 'l-upload-onlyone': limit == 1 && isImg && !drag },
      { 'no-upload-btn': limit == 1 && isImg && value },
      { 'hieUpload': disabled },
      disabled ? 'readonly' : '',
      `upload${custName}`
    ]" action="" :http-request="myUpload" :on-preview="handlePreview" :on-remove="handleRemove"
      :before-remove="beforeRemove" :multiple="clearBefore ? false : multiple" :limit="clearBefore ? 2 : limit"
      :accept="aaccept2" :on-exceed="handleExceed" :on-success="handlesuccess" :before-upload="handleBeforeUpload"
      :auto-upload="isAutoUpload" :file-list="fileList" :data="param"
      :list-type="listType" :show-file-list="myShowFileList" :on-change="onChange" :drag="drag" :disabled="disabled">
      <div v-if="isTip" slot="tip" class="el-upload__tip">{{ tipMsg }}</div>

      <template v-if="!disabled">
        <el-dropdown v-if="!isImg && !drag && !aaccept2 && !onlyLocal" @command="handleCommand">
          <slot>
            <el-button size="mini" :type="btnType" icon="el-icon-plus" style="font-size: 12px;height: 28px">{{
              $t(btnText) }}</el-button>
          </slot>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="localUpload">本地上传</el-dropdown-item>
            <el-dropdown-item command="networkUpload">网盘上传</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <template v-else-if="!isImg && !drag && (aaccept2 || onlyLocal)">
          <slot>
            <el-button size="mini" :type="btnType" icon="el-icon-plus" style="font-size: 12px;height: 28px">{{
              $t(btnText) }}</el-button>
          </slot>
        </template>
        <template v-else-if="drag">
          <i class="el-icon-upload"></i>
          <slot>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </slot>
        </template>
        <i v-else class="el-icon-plus"></i>
      </template>
    </el-upload>



    <l-dialog v-if="!isImg" title="文件预览" :hasBtns="false" :visible.sync="previewVisible" width="1000px"
      :defaultFull="true" :height="800">
      <template #title>
        <div class="flex-space-between" style="width: 100%;padding: 0 16px">
          文件预览
          <el-button size="mini" icon="el-icon-down" type="primary" @click="
            downFile(
              `${apiUrl}system/annexesfile/${previewFileId}?token=${tokenVal}&isGetFileFromTenant=${isUploadToNormal ? true : false}`
            )
            ">下载</el-button>
        </div>
      </template>
      <iframe v-if="previewUrl != ''" :src="previewUrl" style="display: block" class="l-iframe" ref="iframe"
        frameborder="0"></iframe>
      <!-- <template #btns>
        <el-button size="mini" icon="el-icon-down" type="primary" @click="
          downFile(
            `${apiUrl}${downLoadApi}/${previewFileId}?token=${token}`
          )
          ">下载</el-button>
      </template> -->
    </l-dialog>

    <el-dialog :append-to-body="true" v-if="isImg" :visible.sync="previewVisible">
      <img width="100%" :src="previewUrl" alt="" />
    </el-dialog>

    <l-dialog :title="$t(uploadTitle)" :width="400" :modal="false" :hasBtns="false" :hasHeight="false"
      :showMinBtn="true" placement="bottom-right" :visible.sync="loadVisible">
      <div class="learun-file-list dg-box">
        <div v-for="item in uploadingFiles" :key="item.uid" class="learun-list-item">
          <div class="learun-list-item-wraper">
            <div class="learun-list-item-icon">
              <l-fileIcon :name="item._name || item.name" />
            </div>
            <div class="learun-list-item-content">
              <div class="learun-list-item-title">
                {{ item._name || item.name }}
              </div>
            </div>
            <div class="learun-list-item-des" v-if="item.isUploading || item.isSuccess">
              {{ $countFileSize(item.uploadSize) }}/{{
                $countFileSize(item.size)
              }}
            </div>
            <div :title="item.error" class="learun-list-item-des" v-else>
              {{ item.error }}
            </div>
            <div class="learun-list-item-icon">
              <div class="icons">
                <el-progress v-if="item.isUploading" :width="24" :stroke-width="4" type="circle" :show-text="false"
                  :percentage="item.percent">
                </el-progress>
                <i v-else-if="item.isSuccess" class="learun-icon-circle-correct-base learun-success"></i>
                <i v-else class="learun-icon-circle-hint-base learun-error"></i>
              </div>
              <div class="icons-hover">
                <el-tooltip popper-class="learun-tooltip-top" v-if="item.isUploading" effect="dark" content="取消上传"
                  placement="top">
                  <i @click="handleCancelUpload(item)" class="learun-icon-circle-error-base learun-info"></i>
                </el-tooltip>
                <i v-else-if="item.isSuccess" class="learun-icon-circle-correct-base learun-success"></i>
                <el-tooltip popper-class="learun-tooltip-top" v-else effect="dark" content="重新上传" placement="top">
                  <i @click="handleUploadAgain(item)" class="learun-icon-refresh learun-info"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
    </l-dialog>
    <l-fullscreen-dialog :showOk="false" :visible.sync="docVisible" :title="docTitle">
      <div class='doc-container' style="padding: 10px;height: 100%;">
        <l-rich v-model="docContent" style="margin: 0 auto;
      max-width: 800px;
      background-color: #fff;
      border: 1px solid #e5e7eb;" mode="aiEditor"></l-rich>
      </div>
    </l-fullscreen-dialog>
    <el-image-viewer v-if="showViewer" :zIndex="9999" :onClose="closeViewer" :onSwitch="switchHand"
      :url-list="showSrcList" :initial-index="curtIndex"></el-image-viewer>

    <l-file-select ref="fileSelect" :folderId="folderId" @getFile="getFile"></l-file-select>
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { debounce, cloneDeep } from 'lodash';
export default {
  name: "l-upload",
  components: {
    ElImageViewer
  },
  props: {
    isUploadToNormal: {
      default: false
    },
    value: {},
    disabled: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 1,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    maxSize: String,
    sizeType: String,
    accept: String,

    isTip: Boolean,
    showFileList: {
      type: [Boolean, String],
      default: true,
    },
    listType: String,

    drag: {
      type: Boolean,
      default: false,
    },

    btnText: {
      type: String,
      default: "点击上传",
    },
    btnType: {
      type: String,
      default: "text",
    },

    isNotUpLoad: {
      type: Boolean,
      default: false,
    },
    isNotDelete: {
      type: Boolean,
      default: false,
    },
    directory: {
      type: String,
      default: "",
    },
    uploadFolder: {
      default: false
    },

    upload: Function,
    uploadCallback: Function, // 返回(formData, param)
    // 是否需要记录变更历史
    log: {
      default: '',
    },
    needMerge: {
      default: false
    },
    // 是否可以重复上传
    reUpload: {
      default: false
    },
    clearBefore: {
      default: false // 覆盖上传
    },
    autoUpload: {
      default: true
    },
    createFolderHandler: {
      default: ''
    },
    uploadApi: {
      default: 'system/annexesfile'
    },
    onlyLocal: {
      default: false // 只允許本地上传
    },
    noToken: {
      default: false // 不需要token访问
    },
    notInitFolderId: {
      default: false // 默认获取到文件列表为空时会置空文件夹id
    }
  },
  watch: {
    value: {
      handler(val, oldVal) {
        if (this.$validatenull(val)) {
          this.folderId = this.$uuid();
          this.fileList = [];
        } else {
          // 加载列表页
          if (
            (val != oldVal && !this.$validatenull(oldVal)) ||
            val != this.folderId
          ) {
            // 
            this.handleLoadFileList(val);
          }
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      docVisible: false,
      docContent: '',
      docTitle: '',
      custName: "",
      showSrcList: [],
      curtIndex: 0,
      showViewer: false,
      folderId: "",
      fileList: [],
      uploadFiles: [],

      previewVisible: false,
      previewFileId: "",
      previewUrl: "",

      loadVisible: false,
      uploadingFiles: [],
      newVal: ''
    };
  },
  created() {
    this.custName = this.$uuid()
    this.folderId = this.$uuid();
  },
  mounted() {

    this.$nextTick(() => {

      if (this.uploadFolder) {
        this.$refs.upload.$children[0].$refs.input.webkitdirectory = true
      }
    })
  },
  computed: {
    isAutoUpload() {
      if (this.createFolderHandler) return false
      return this.autoUpload
    },
    param() {
      return {
        folderId: this.newVal || this.value || this.folderId,
        maxSize: this.maxSize,
        sizeType: this.sizeType,
        directory: this.directory
      };
    },
    tipMsg() {
      return `只能上传不超过${this.maxSize || ""}${this.sizeType || ""}的${this.accept || ""
        }文件`;
    },
    isImg() {
      return this.listType == "picture-card";
    },
    aaccept2() {
      if (this.isImg) {
        return "image/*";
      } else {
        return this.accept;
      }
    },
    uploadTitle() {
      if (this.uploadingFiles.filter((t) => t.isUploading).length > 0) {
        const successNum = this.uploadingFiles.filter(
          (t) => t.isSuccess
        ).length;
        return `上传中...${successNum}/${this.uploadingFiles.length}`;
      } else {
        const cancelNum = this.uploadingFiles.filter((t) => t.isCancel).length;
        const failNum =
          this.uploadingFiles.filter((t) => t.isSuccess == false).length -
          cancelNum;

        let title = "";
        if (failNum > 0) {
          title += `${failNum}个上传失败`;
        }
        if (cancelNum > 0) {
          if (title != "") {
            title += ",";
          }
          title += `${cancelNum}个上传取消`;
        }

        if (title == "") {
          return "上传完成";
        }

        return title;
      }
    },
    myShowFileList() {
      if (this.showFileList == true) {
        return true;
      } else {
        return false;
      }
    },
    downLoadApi() {
      return this.uploadApi == 'system/file' ? `${this.uploadApi}/download` : this.uploadApi
    },
    srcList() {
      let arr = []
      this.fileList.forEach(e => {
        if (e.url) {
          arr.push(e.url)
        } else {
          arr.push(`${this.apiUrl}${this.uploadApi}/${fileId}?token=${this.tokenVal}&isGetFileFromTenant=${this.isUploadToNormal ? true : false}`)
        }
      })
      return arr
    },
    tokenVal() {
      return this.noToken ? "img" : this.token;
    }
  },
  methods: {
    getFile(arr) {
      let temp = arr.map(i => i.id)

      window.$axios({
        url: `${this.uploadApi}/netfile/${this.param.folderId}${this.noToken ? '?token=img' : ''}`,
        method: "post",
        data: temp,
        meta: {
          isToken: this.noToken ? false : true
        }
      }).then(async (res) => {
        this.$emit("input", this.param.folderId);
        this.$refs.fileSelect.closeFileSelect()
        // setTimeout(() => {
        //   this.handleLoadFileList(this.param.folderId)
        // },100)

        let data = await this.lr_getFileList(this.param.folderId, this.uploadApi, this.noToken);
        if (data.length > 0) {
          let ids = this.fileList.map(i => i.id).toString()
          if (ids) {
            data = cloneDeep(data.filter(i => ids.indexOf(i.id) == -1))
          }
          this.fileList = cloneDeep(this.fileList.concat(data))
        }

        this.renderFileIcon()

      })



    },
    handleCommand(e) {
      if (e == 'localUpload') {
        this.localUpload(`.upload${this.custName}`)
      } else {
        this.networkUpload()
      }
    },
    networkUpload() {
      this.$refs.fileSelect.openFileSelect()
    },
    localUpload(el) {
      const upload = document.querySelector(el);
      upload.childNodes[0].click()
    },
    handleOk() {

    },
    closeViewer() {
      this.showViewer = false;
    },
    switchHand(e) {
      this.curtIndex = e + 1;
    },
    createFolder(file, fileList) {
      this.createFolderHandler(file, fileList).then(() => {
        this.$refs.upload.submit()
      })
    },
    onChange(file, fileList) {

      if (this.createFolderHandler) {
        this.$lastOpt('createFolder', () => {
          this.createFolder(file, fileList)
        })
      }
      this.renderFileIcon()
    },
    dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.componentName;
      // 从这里可以看出是找到对应的组件对象
      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;
        if (parent) {
          name = parent.$options.componentName;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    async handleLoadFileList(val) {
      if (this.lr_getFileList) {
        let data = await this.lr_getFileList(val, this.uploadApi, this.noToken);
        if (val == this.value) {
          this.fileList = data;
          this.$emit('getFileList', data)
        }
        if (data.length == 0) {
          if (!this.notInitFolderId) this.$emit("input", "");
        }
        this.renderFileIcon()
      }

    },
    clearFiles() {
      this.$refs.upload.clearFiles()
    },
    async handlesuccess(response, file, fileList) {
      this.uploadFiles.push(response);
      if (!this.value) {
        this.$emit("input", response.folderId);
        setTimeout(() => {
          this.dispatch("ElFormItem", "el.form.blur", ["xxx"]);
        });
      } else if (this.clearBefore) {
        this.$emit("input", response.folderId);
        setTimeout(() => {
          this.dispatch("ElFormItem", "el.form.blur", ["xxx"]);
        });
      }
      if (this.clearBefore && fileList.length > 1) {
        await this.handleRemove(fileList[0])
        fileList.splice(0, 1)
      }
      this.$emit("success", response);
      this.$emit('change')
      if (this.reUpload) {
        !this.clearBefore && this.$refs.upload.clearFiles()
      }
      if (this.lr_getFileList) {
        let data = await this.lr_getFileList(response.folderId, this.uploadApi, this.noToken)
        this.$emit('getFileList', data)
        this.renderFileIcon()
      }
    },
    saveLog() {
      if (this.log) {
        window.$axios({
          method: 'put',
          url: `${this.log}/${this.param.folderId}`,
          meta: {
            isToken: this.noToken ? false : true
          }
        })
      }
    },
    async handleRemove(file) {
      return new Promise((resolve) => {
        if (file.response) {
          if (!this.isNotDelete) {
            this.lr_deleteFile && this.lr_deleteFile(file.response.fileId, this.uploadApi,this.isUploadToNormal, this.noToken).then(() => {
              this.saveLog()
              this.$emit('change')
              resolve()
            });
          }
          this.uploadFiles.splice(
            this.uploadFiles.findIndex((t) => t.fiinputleId == file.response.fileId),
            1
          );
        } else if (file.id) {
          if (!this.isNotDelete) {
            this.lr_deleteFile && this.lr_deleteFile(file.id, this.uploadApi,this.isUploadToNormal, this.noToken).then(() => {
              this.saveLog()
              this.$emit('change')
              resolve()
            });
          } else {
            this.$emit('delete', file.id)
          }
          this.fileList.splice(
            this.fileList.findIndex((t) => t.id == file.id),
            1
          );
        }

        if (this.uploadFiles.length == 0 && this.fileList.length == 0) {
          if (!this.notInitFolderId) this.$emit("input", "");
        }
        this.$emit('getFileList', this.fileList)
      })
    },
    async handlePreview(file) {
      const fileExt = file.name.split(".")[file.name.split(".").length - 1];
      let fileId = file.id || file.response.fileId;
      let uploadApi = this.uploadApi
      let item = this.fileList.find(e => e.f_Id == fileId) || {}
      if (item.f_IsOnlineFile) {
        let result = await this.$awaitWraper(window.$axios({
          url: `system/file/filedto/${item.f_FilePath}${this.noToken ? '?token=img' : ''}`,
          method: 'get',
          meta: {
            isToken: this.noToken ? false : true
          }
        }))
        if (result) {
          let doc = await this.$awaitWraper(window.$axios({
            url: `onlinefile/${result.fileId}${this.noToken ? '?token=img' : ''}`,
            method: 'get',
            meta: {
              isToken: this.noToken ? false : true
            }
          }))
          this.docContent = doc.f_FileContent
          this.docTitle = doc.f_FileName
          this.docVisible = true
        } else {
          this.$tip('在线文档已不存在', 'warning')
        }
        return
      }
      if (item.f_IsNetFile) {
        let result = await this.$awaitWraper(window.$axios({
          url: `system/file/filedto/${item.f_FilePath}${this.noToken ? '?token=img' : ''}`,
          method: 'get',
          meta: {
            isToken: this.noToken ? false : true
          }
        }))
        if (!result) this.$tip('网盘文件已被删除', 'warning')
        uploadApi = 'system/file'
        fileId = result.fileId
      }
      if (!this.isImg && this.$getCanPreviewTypes().includes(fileExt)) {
        if (this.$validatenull(this.apiUrl)) {
          return;
        }
        this.previewUrl = this.$getPreviewUrl({
          uploadApi,
          fileId: fileId,
          name: file.name,
          downLoad: true,
          print: true,
          noToken: this.noToken,
          isUploadToNormal: this.isUploadToNormal
        });
        this.previewFileId = fileId;
        this.previewVisible = true;
      } else if (this.imgTypes.includes(fileExt)) {
        if (this.isImg) {
          if (file.url) {
            this.previewUrl = file.url;
          } else {
            if (this.$validatenull(this.apiUrl)) {
              return;
            }
            this.previewUrl = `${this.apiUrl}${uploadApi}/${fileId}?token=${this.tokenVal}&isGetFileFromTenant=${this.isUploadToNormal ? true : false}`;
          }
          // this.previewVisible = true;

          if (this.srcList.length) {
            this.showSrcList = this.srcList
          } else {
            this.showSrcList = [this.previewUrl]
          }
          this.curtIndex = this.showSrcList.findIndex(j => j == this.previewUrl)
          if (this.curtIndex == -1) {
            this.curtIndex = 0
            this.showSrcList = [this.previewUrl]
          }
          this.showViewer = true;
        } else {
          if (this.$validatenull(this.apiUrl)) {
            return;
          }
          this.previewUrl = `${this.apiUrl}${uploadApi}/preview/${fileId}?token=${this.tokenVal}&isGetFileFromTenant=${this.isUploadToNormal ? true : false}`;
          this.previewFileId = fileId;
          this.previewVisible = true;
        }
      } else {
        // 不支持预览，就直接下载
        this.$message.warning(`当前文件格式不支持预览${fileExt}`);
        if (this.$validatenull(this.apiUrl)) {
          return;
        }
        this.downFile(
          `${this.apiUrl}${this.downLoadApi}/${fileId}?token=${this.tokenVal}`
        );
      }
      // switch (fileExt) {
      //   case "xls":
      //   case "xlsx":
      //   case "docx":
      //   case "txt":
      //   case "csv":
      //   case "html":
      //   case "pdf":
      //     if (this.$validatenull(this.apiUrl)) {
      //       return;
      //     }
      //     // this.previewUrl = `${this.apiUrl}${this.uploadApi}/preview/${fileId}?token=${this.token}`;
      //     this.previewUrl = this.$getPreviewUrl({
      //       uploadApi: this.uploadApi,
      //       fileId: fileId,
      //       name: file.name,
      //       downLoad: true,
      //       print: true,
      //     });
      //     this.previewFileId = fileId;
      //     this.previewVisible = true;
      //     break;
      //   case "jpg":
      //   case "gif":
      //   case "png":
      //   case "bmp":
      //   case "jpeg":
      //   case "svg":
      //     if (this.isImg) {
      //       if (file.url) {
      //         this.previewUrl = file.url;
      //       } else {
      //         if (this.$validatenull(this.apiUrl)) {
      //           return;
      //         }
      //         this.previewUrl = `${this.apiUrl}${this.uploadApi}/${fileId}?token=${this.token}`;
      //       }
      //       this.previewVisible = true;
      //     } else {
      //       if (this.$validatenull(this.apiUrl)) {
      //         return;
      //       }
      //       this.previewUrl = `${this.apiUrl}${this.uploadApi}/preview/${fileId}?token=${this.token}`;
      //       this.previewFileId = fileId;
      //       this.previewVisible = true;
      //       break;
      //     }

      //     break;
      //   default:
      //     // 不支持预览，就直接下载
      //     this.$message.warning(`当前文件格式不支持预览${fileExt}`);
      //     if (this.$validatenull(this.apiUrl)) {
      //       return;
      //     }
      //     this.downFile(
      //       `${this.apiUrl}${this.downLoadApi}/${fileId}?token=${this.token}`
      //     );
      //     break;
      // }
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file) {
      if (!this.compareSize(file.size)) {
        return true;
      }
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    downFile(url) {
      this.$downFile(`${url}`);
    },
    async handleBeforeUpload(file) {
      if (this.clearBefore) this.folderId = this.newVal = this.$uuid()
      if (!this.compareSize(file.size)) {
        this.$message.warning("上传文件超出大小了");
        this.$emit('change')
        return false;
      }
      this.$emit('startUpload')
    },
    compareSize(fileSize) {
      if (this.maxSize && this.sizeType) {
        let size = fileSize;
        switch (this.sizeType) {
          case "GB":
            size = 1024 * 1024 * 1024 * Number(this.maxSize);
            break;
          case "MB":
            size = 1024 * 1024 * Number(this.maxSize);
            break;
          case "KB":
            size = 1024 * Number(this.maxSize);
            break;
          case "B":
          default:
            size = Number(this.maxSize);
            break;
        }
        if (size < fileSize) {
          return false;
        }
      }
      return true;
    },
    myUpload(option) {
      if (!this.compareSize(option.file.size)) {
        return false;
      }
      option.directory = this.directory
      option.log = this.log
      option.needMerge = this.needMerge
      option.uploadApi = this.uploadApi
      option.saasMode = this.saasMode
      option.isUploadToNormal = this.isUploadToNormal
      option.noToken = this.noToken
      if (!this.isNotUpLoad) {
        if (this.upload) {
          this.upload(option);
          return;
        } else if (this.showFileList == "bottom") {
          this.upLoadFiles([option.file]);
        } else if (this.lr_chunkedUpload) {
          this.lr_chunkedUpload(option, this.uploadCallback);
          return;
        }
      }
      const { file } = option;
      option.onSuccess({
        name: file.name,
      });
    },

    closeUpLoadFileForm() {
      this.loadVisible = false;
    },
    upLoadFiles(files, params) {
      if (!this.loadVisible) {
        this.uploadingFiles = this.uploadingFiles.filter((t) => t.isUploading);
      }
      files = files || [];
      if (files.length > 0) {
        files.forEach((file) => {
          let option = {
            data: this.param,
            filename: file.name,
            file,
            onProgress: this.onUpLoadProgress,
            onSuccess: this.onUpLoadSuccess,
            onError: this.onError,
            onStart: this.onStart,
            directory: this.directory,
            log: this.log,
            needMerge: this.needMerge,
            ...params,
            uploadApi: this.uploadApi,
            noToken: this.noToken
          };
          if (file.params) option = Object.assign(option, file.params)
          file.isUploading = true;
          file.uploadSize = 0;
          const fileIcon = this.lr_getFileIcon(file.name, file.type);
          file.icon = fileIcon.icon;
          file.color = fileIcon.color;
          this.lr_chunkedUpload(option, this.uploadCallback);
        });

        this.uploadingFiles.push(...files);
        this.loadVisible = true;
      }
    },
    onStart({ uid, xhr, chunks, id }) {
      const file = this.uploadingFiles.find((t) => t.uid == uid);
      if (file) {
        file.xhrs = file.xhrs || [];
        file.xhrs.push(xhr);
        file.chunks = chunks;
        file.id = id;
      }
    },
    onUpLoadProgress({ uid, fileSize, percent }) {
      const file = this.uploadingFiles.find((t) => t.uid == uid);
      if (file) {
        if (file.isCancel) {
          return;
        }
        file.uploadSize = fileSize;
        file.percent = percent;
        if (percent == 100) {
          file.xhrs == null;
        }
        this.$set(this.uploadingFiles, 0, this.uploadingFiles[0]);
      }
    },
    onUpLoadSuccess({ uid }) {
      const file = this.uploadingFiles.find((t) => t.uid == uid);
      if (file) {
        file.isSuccess = true;
        file.isUploading = false;
        this.$set(this.uploadingFiles, 0, this.uploadingFiles[0]);

        this.$emit("success", file);
      }
    },
    onError(error, uid) {
      const file = this.uploadingFiles.find((t) => t.uid == uid);
      if (file) {
        if (file.isCancel) {
          return;
        }
        file.isSuccess = false;
        file.isUploading = false;
        file.error = error;
        this.$set(this.uploadingFiles, 0, this.uploadingFiles[0]);
      }
      console.error(error, "文件上传错误！");
    },

    async handleCancelUpload(file) {
      if (file.percent == 100) {
        // 文件分片已经上传完了无法取消
        this.$message({
          type: "warning",
          message: this.$t("已经上传无法取消！"),
        });
      }

      if (file.xhrs) {
        // 取消文件上传，需要清空已经上传的文件分片
        file.xhrs.forEach((xhr) => {
          xhr.abort();
        });
        if (this.lr_removeFileChunks) {
          await this.lr_removeFileChunks(file.id, file.chunks);
        }
      }
      file.isSuccess = false;
      file.isUploading = false;
      file.error = "取消上传";
      file.isCancel = true;
      this.$set(this.uploadingFiles, 0, this.uploadingFiles[0]);
    },
    handleUploadAgain(file) {
      file.isUploading = true;
      file.uploadSize = 0;
      file.error = "";
      file.isCancel = false;

      const option = {
        data: this.param,
        filename: file.name,
        file,
        onProgress: this.onUpLoadProgress,
        onSuccess: this.onUpLoadSuccess,
        onError: this.onError,
        onStart: this.onStart,
        directory: this.directory,
        log: this.log,
        needMerge: this.needMerge,
        uploadApi: this.uploadApi,
        noToken: this.noToken,
      };

      this.lr_chunkedUpload(option, this.uploadCallback);
    },
    renderFileIcon() {
      //找出所有文件图标的class

      this.$nextTick(() => {
        let fileElementList = document.getElementsByClassName('el-upload-list__item-name');
        if (fileElementList && fileElementList.length > 0) {
          for (let ele of fileElementList) {
            let fileName = ele.innerText;
            //获取文件名后缀
            let fileType = fileName.substring(fileName.lastIndexOf(".") + 1);
            let iconElement = ele.getElementsByTagName('i')[0];
            if (['png', 'jpg', 'jpeg', ".gif", 'PNG', 'JPG', 'JPEG', "GIF"].indexOf(fileType) != -1) {
              iconElement.className = "imgicon-img" // 图⽚，动图
            } else if (['mp4', '3gp', 'avi', "flv", 'MP4', '3GP', 'AVI', "FLV"].indexOf(fileType) != -1) {
              iconElement.className = 'imgicon-video' // 视频
            } else if (['doc', 'docx', 'DOC', 'DOCX'].indexOf(fileType) != -1) {
              iconElement.className = 'imgicon-docx' // 文档
            } else if (['xls', 'xlsx', 'XLS', 'XLSX'].indexOf(fileType) != -1) {
              iconElement.className = 'imgicon-xlsx' // 表格
            } else if (['ppt', 'pptx', 'PPT', 'PPTX'].indexOf(fileType) != -1) {
              iconElement.className = 'imgicon-pptx' // PPT
            } else if (['zip', 'ZIP'].indexOf(fileType) != -1) {
              iconElement.className = 'imgicon-zip' // 压缩包
            } else if (['pdf', 'PDF'].indexOf(fileType) != -1) {
              iconElement.className = 'imgicon-pdf' // PDF
            } else if (['mp3', 'audio'].indexOf(fileType) != -1) {
              iconElement.className = 'imgicon-mp3' // mp3
            } else if (['config'].indexOf(fileType) != -1) {
              iconElement.className = 'imgicon-config' // config
            } else if (['exe'].indexOf(fileType) != -1) {
              iconElement.className = 'imgicon-exe' // exe
            } else if (['html', 'web'].indexOf(fileType) != -1) {
              iconElement.className = 'imgicon-web' // web
            } else {
              iconElement.className = 'imgicon-default' //默认图标
            }
          }
        }
      })
    },
    /*uploadDialogOpen(){
            this.uploadingFiles = this.uploadingFiles.filter(t=>t.isUploading)
        }*/
  },
}; 
</script>
<style lang="less" scoped>
@import "./index.less";

::v-deep {
  .hieUpload {
    .el-upload {
      display: none !important;
    }
  }

  .myupload .imgicon-video {
    display: inline-block;
    width: 18px;
    margin-bottom: -4px;
    height: 18px;
    background-size: 100% 100%;
    margin-right: 3px;
    background-image: url("/img/fileType/file_video.png");
  }

  .myupload .imgicon-img {
    display: inline-block;
    width: 18px;
    margin-bottom: -4px;
    height: 18px;
    background-size: 100% 100%;
    margin-right: 3px;
    background-image: url("/img/fileType/file_pic1.png");
  }

  .myupload .imgicon-pdf {
    display: inline-block;
    width: 18px;
    margin-bottom: -4px;
    height: 18px;
    background-size: 100% 100%;
    margin-right: 3px;
    background-image: url("/img/fileType/file_pdf.png") !important;
  }

  .myupload .imgicon-docx {
    display: inline-block;
    width: 18px;
    margin-bottom: -4px;
    height: 18px;
    background-size: 100% 100%;
    margin-right: 3px;
    background-image: url("/img/fileType/file_doc.png") !important;
  }

  .myupload .imgicon-zip {
    display: inline-block;
    width: 18px;
    margin-bottom: -4px;
    height: 18px;
    background-size: 100% 100%;
    margin-right: 3px;
    background-image: url("/img/fileType/file_rar.png") !important;
  }

  .myupload .imgicon-pptx {
    display: inline-block;
    width: 18px;
    margin-bottom: -4px;
    height: 18px;
    background-size: 100% 100%;
    margin-right: 3px;
    background-image: url("/img/fileType/file_ppt.png") !important;
  }

  .myupload .imgicon-xlsx {
    display: inline-block;
    width: 18px;
    margin-bottom: -4px;
    height: 18px;
    background-size: 100% 100%;
    margin-right: 3px;
    background-image: url("/img/fileType/file_xls.png") !important;
  }

  .myupload .imgicon-web {
    display: inline-block;
    width: 18px;
    margin-bottom: -4px;
    height: 18px;
    background-size: 100% 100%;
    margin-right: 3px;
    background-image: url("/img/fileType/file_web1.png") !important;
  }

  .myupload .imgicon-mp3 {
    display: inline-block;
    width: 18px;
    margin-bottom: -4px;
    height: 18px;
    background-size: 100% 100%;
    margin-right: 3px;
    background-image: url("/img/fileType/file_audio.png") !important;
  }

  .myupload .imgicon-config {
    display: inline-block;
    width: 18px;
    margin-bottom: -4px;
    height: 18px;
    background-size: 100% 100%;
    margin-right: 3px;
    background-image: url("/img/fileType/file_config.png") !important;
  }

  .myupload .imgicon-exe {
    display: inline-block;
    width: 18px;
    margin-bottom: -4px;
    height: 18px;
    background-size: 100% 100%;
    margin-right: 3px;
    background-image: url("/img/fileType/file_exe.png") !important;
  }

  .myupload .imgicon-default {
    display: inline-block;
    width: 18px;
    margin-bottom: -4px;
    height: 18px;
    background-size: 100% 100%;
    margin-right: 3px;
    background-image: url("/img/fileType/file_unkonwn.png") !important;
  }
}
</style>
